// Presentation-only Region labels for public filter picker (RIC-5.6D2).

export function formatRegionFilterLabel(region) {
  if (!region || !region.name) {
    return "";
  }
  if (region.category === "K") {
    return `м. ${region.name}`;
  }
  const name = region.name;
  if (
    name.includes("область") ||
    name.includes("Крим") ||
    name.includes("Автономна")
  ) {
    return name;
  }
  return `${name} область`;
}
